import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PatchProfileResponse } from '@ab/ams-school-api/types/private/v1';
import { config } from '~/config';
import { useRequest } from '~/lib/useRequest';
import { hasKey } from '~/utils';

export type PatchStudentEmailPayload = {
  profileId: string;
  email: string;
};

export function usePatchStudentEmail() {
  const request = useRequest();
  const queryClient = useQueryClient();
  const { isLoading, error, mutateAsync } = useMutation(['profile'], async (payload: PatchStudentEmailPayload) => {
    const response = await request<PatchProfileResponse>(
      `${config.apiHost}/private/v1/profiles/${payload.profileId}/admin_change_email`,
      {
        method: 'PATCH',
        body: {
          data: {
            id: payload.profileId,
            type: 'profile',
            attributes: {
              email: payload.email,
            },
          },
        },
        isExpectedResponse,
      }
    );

    queryClient.invalidateQueries(['application']);

    return response.data;
  });

  return {
    patchStudentEmail: mutateAsync,
    patchStudentEmailError: error,
    isPatchingStudentEmail: isLoading,
  };
}

function isExpectedResponse(res: unknown): res is PatchProfileResponse {
  return Boolean(res && typeof res === 'object' && hasKey('data', res));
}
